import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
} from '@angular/core';

import { Filter } from '../../../interfaces/user.interface';

@Component({
    selector: 'mapp-multiselect',
    templateUrl: './multiselect.component.html',
    styleUrls: ['./multiselect.component.scss'],
    standalone: false,
})
export class MultiselectComponent implements OnChanges {
    @Input() filter: Filter;

    @Input() selectedValues: string[] = [];

    @Input() isMultiselect = true;

    @Input() defaultPlaceholder = 'Select items';

    @Input() isDisabled: boolean;

    @Input() showLoader: boolean;

    @Input() loaderMessage: string;

    @Input() isOptionDisabled = false;

    @Output() selectedValuesChange = new EventEmitter<string[]>();

    placeholder = '';

    showDropdown = false;

    /**
     *
     * @param elementRef
     */
    constructor(private elementRef: ElementRef) {}

    /**
     *
     */
    ngOnChanges() {
        this.adaptPlaceholder();
    }

    /**
     *
     */
    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
    }

    /**
     *
     * @param option
     */
    toggleSelection(option: string) {
        if (!this.isMultiselect) {
            this.selectedValues = [option];
            this.showDropdown = false;
        }

        if (this.isMultiselect) {
            this.selectedValues = this.isSelected(option)
                ? this.selectedValues.filter((value) => value !== option)
                : [...this.selectedValues, option];
        }

        this.adaptPlaceholder();
        this.selectedValuesChange.emit(this.selectedValues);
    }

    /**
     *
     */
    adaptPlaceholder() {
        switch (this.selectedValues?.length) {
            case 0:
            case undefined:
                this.placeholder = this.defaultPlaceholder;
                break;
            case 1:
                this.placeholder =
                    this.filter.options.find((option) => option === this.selectedValues[0]) || '';
                break;
            default:
                this.placeholder = `${this.selectedValues?.length} items selected`;
        }
    }

    /**
     *
     * @param option
     */
    isSelected(option: string): boolean {
        return this.selectedValues?.includes(option);
    }

    /**
     *
     * @param values
     */
    setSelectedValues(values: string[]) {
        this.selectedValues = values;
        this.adaptPlaceholder();
    }

    /**
     *
     * @param event
     */
    @HostListener('document:click', ['$event'])
    onClick(event: MouseEvent) {
        const targetElement = event.target as HTMLElement;
        if (!this.showDropdown || this.elementRef.nativeElement.contains(targetElement)) {
            return;
        }
        this.showDropdown = false;
    }
}
